import styled from 'styled-components';

const StyledContainer = styled.div`
	position: relative;

	& > input ~ img {
		position: absolute;
		top: 50%;
		right: 15px;
		transform: translateY(-50%);
		opacity: 0.5;
		transition:
			filter 0.3s ease,
			opacity 0.3s ease;
	}

	& > input:hover ~ img {
		opacity: 1;
		filter: invert(100%);
	}
`;

export { StyledContainer };
